import * as $ from 'jquery';
import {config, defaultAlertModal, goToAuthPage, isApp,
    showModalFromTemplate} from '../utils.js';
import {daysDiff} from '../utils/date.js';
import {money} from '../money.js';
import {OfferCreatedEvent} from '../Shared/events/OfferCreatedEvent.js';
import {post} from '../utils/ajax.js';
import {sendAppEvent} from '../tracking/app-events.js';
import {setRangeTrackColors} from '../styles/form-styles.js';

const setMakeOffer = async () => {
  const {offerData, status} = await retrieveData(config.product_id);
  document.addEventListener('click', async (e) => {
    if (!e.target?.classList.contains('btn-buy-offer')) return;
    e.preventDefault();
    if (!offerData) {
      handleUnavailableOffer(status);
      return;
    }
    showModalFromTemplate('#tmpl-modal-make-offer-test', () => {
      const form = document.getElementById('offer-form');
      const input = document.querySelector('.js-offer-input');
      const range = document.querySelector('.js-offer-range');
      const rangeBg = '#e6e6e6'; //--color-border-disable default range backgrond color
      const hidden = document.querySelector('.js-offer-input-hidden');
      const submit = document.querySelector('.js-offer-submit-btn');
      const buyNow = document.querySelector('.js-offer-buy-now-btn');
      const stateBanners = document.querySelectorAll('.js-offer-banner');
      const messagePrice = document.querySelector('.js-message-price');
      const elems = {form, input, range, rangeBg, hidden, submit, buyNow,
          stateBanners, messagePrice, offerData};
      setInitialValues(elems);
      setLimitedBanner(elems);
      setOfferInputs(elems);
    });
  });
};

// Las opciones de oferta se piden al cargar la página, así que un 401 aquí
// significa que la sesión ya no es válida aunque la página se haya renderizado
// como logueada. En ese caso mandamos a login en vez de dejar el botón muerto.
const handleUnavailableOffer = (status) => {
  if (status !== 401) {
    defaultAlertModal('Ha ocurrido un error');
    return;
  }
  if (isApp()) {
    window.location.href = '/app/auth';
    return;
  }
  goToAuthPage();
};

const setOfferInputs = (elems) => {
  if (!elems.input || !elems.range || !elems.hidden || !elems.submit) return;
  document.addEventListener('money-input-change', () => {
    dispatchOfferChange();
  });
  setRangeTrackColors(
      elems.range, getComputedStyle(elems.range).accentColor, elems.rangeBg);
  elems.range.addEventListener('input', () => {
    elems.hidden.value = elems.range.value;
    dispatchOfferChange();
  });
  document.addEventListener('offer-change', () => {
    linkInputs(elems);
    toogleForm(elems, isValidInput(elems));
    updateOfferState(elems, parseInt(elems.hidden.value));
    setRangeTrackColors(elems.range, getComputedStyle(elems.range).accentColor,
        elems.rangeBg);
  });
  manageForm(elems);
};

const isValidInput = (elems) => !isAboveMax(elems) && !isBelowMin(elems);

const isAboveMax = (elems) =>
    parseInt(elems.hidden.value) > parseInt(elems.range.max);

const isBelowMin = (elems) =>
    parseInt(elems.hidden.value) < parseInt(elems.range.min);

const toogleForm = (elems, active) => {
  const wrapper = elems.hidden.closest('.input-wrapper');
  elems.hidden.toggleAttribute('disabled', !active);
  elems.submit.toggleAttribute('disabled', !active);
  wrapper.classList.toggle('error', !active);
};

const dispatchOfferChange = () => {
  const event = new CustomEvent('offer-change');
  document.dispatchEvent(event);
};

const linkInputs = (elems) => {
  elems.input.value = money(elems.hidden.value);
  elems.range.value = elems.hidden.value;
};

const setRangeClass = (elems, className) => {
  elems.range.classList.remove('error', 'warning', 'success');
  elems.range.classList.add(className);
};

const updateOfferState = (elems, value) => {
  const offerLow = parseInt(elems.offerData.recommended_amount);
  const declinedOffer = parseInt(elems.offerData.highest_rejected_amount);
  const minOffer = parseInt(elems.offerData.min_amount);
  const maxPrice = parseInt(elems.offerData.max_amount);
  const bannerDeclinedPrice =
  document.querySelector('.js-offer-banner-info-declined-price');
  const bannerLowPrice =
  document.querySelector('.js-offer-banner-info-low-price');
  const bannerGoodPrice =
  document.querySelector('.js-offer-banner-info-good-price');
  const bannerCurrentPrice =
  document.querySelector('.js-offer-banner-info-current-price');
  elems.stateBanners.forEach(banner => {
    banner.classList.add('d-none');
    if (value < minOffer) {
      setRangeClass(elems, 'error');
      showBuyNow(elems, false);
    } else if (value <= declinedOffer) {
      bannerDeclinedPrice.classList.remove('d-none');
      setRangeClass(elems, 'error');
      showBuyNow(elems, false);
    } else if (value >= minOffer && value < offerLow) {
      bannerLowPrice.classList.remove('d-none');
      setRangeClass(elems, 'warning');
      showBuyNow(elems, false);
    } else if (value >= offerLow && value < maxPrice) {
      bannerGoodPrice.classList.remove('d-none');
      setRangeClass(elems, 'success');
      showBuyNow(elems, false);
    } else { // Offer equals product price
      bannerCurrentPrice.classList.remove('d-none');
      setRangeClass(elems, 'success');
      showBuyNow(elems, true);
    }
  });
  elems.messagePrice.innerHTML = money(value);
};

const showBuyNow = (elems, show) => {
  elems.submit.classList.toggle('d-none', show);
  elems.buyNow.classList.toggle('d-none', !show);
};

const manageForm = (elems) => {
  elems.form.addEventListener('submit', e => {
    e.preventDefault();
    elems.submit.setAttribute('disabled', '');

    const message = elems.form.querySelector('[name="message"]').value ?? '';
    const data = {
      amount: elems.hidden.value,
      message: message
    };

    post(`/api/v5/products/${config.product_id}/offers`, data)
    .then(resp => {
      if (resp.code === 400) {
        defaultAlertModal(resp.errors.product_id || resp.errors.message);
        return;
      }
      const countrySeller = document.getElementById('product-sheet')?.dataset.biCountrySeller || '';
      const offerCreatedEvent = new OfferCreatedEvent(config.user.id,
          config.product_id, data.amount, elems.offerData.max_amount, message,
          resp.id, config.owner, countrySeller);
      document.dispatchEvent(offerCreatedEvent);
      // La app lo reenvía a CleverTap como offer_create_buyer
      const p = JSON.parse(document.getElementById(
          `json-product-${config.product_id}`)?.textContent || '{}');
      sendAppEvent('offer', {product_id: config.product_id,
          price: elems.offerData.max_amount, offer_amount: data.amount,
          product_name: p.name, slug: p.slug, user_id_lister: p.owner,
          category: p.category, vertical: p.vertical});
      $('#modal-make-offer').on('hidden.bs.modal', () => {
          $('#modal-offer-done').modal('show');
      });
      $('#modal-offer-done').on('hidden.bs.modal', () => {
          if (!window.location.hash) {
            window.location.href =
                window.location.href + `#comment-${resp.comment_id}`;
          }
          location.reload();
      });
      $('#modal-make-offer').modal('hide');  
    });
  });
};

const retrieveData = async (productId) => {
  try {
    const response = await fetch(`/api/v5/products/${productId}/offers`, {method: 'OPTIONS'});
    if (!response.ok) return {offerData: null, status: response.status};
    return {offerData: await response.json(), status: response.status};
  } catch {
    return {offerData: null, status: null};
  }
};

const setInitialValues = (elems) => {
  const data = elems.offerData;
  for (const key in data) {
    document.querySelectorAll(`.js-money-${key}`).forEach(
        elem => elem.textContent = data[key] ? money(data[key]) : '');
    document.querySelectorAll(`.js-${key}`).forEach(
        elem => elem.textContent = data[key] ? data[key] : '');
  }
  elems.range.min = data.min_amount;
  elems.range.max = data.max_amount;
  elems.range.step = data.step;
  elems.range.value = data.max_amount;
};

const setLimitedBanner = (elems) => {
  if (elems.offerData.user_limited) {
    const now = new Date();
    const then = new Date(elems.offerData.user_limited_until);
    const diff = daysDiff(now, then);
    const days = diff.days > 0 ?
        diff.days + ` día${diff.days != 1 ? 's' : ''}, ` : '';
    const hours = diff.hours > 0 ?
        diff.hours + ` hora${diff.hours != 1 ? 's' : ''} y ` : '';
    const minutes = diff.minutes > 0 ?
        diff.minutes + ` minuto${diff.minutes != 1 ? 's' : ''}` : '';
    document.querySelector('.js-limited-until').textContent =
        days + hours + minutes;

    const limitation = elems.offerData.days_limitation;
    document.querySelector('.js-days-limitation').textContent =
        limitation == 1 ? 'por día' : `cada ${limitation} días`;
    
    document.querySelector('.js-offer-banner-limited')
        .classList.remove('d-none');
  }
};

export {setMakeOffer};